// export { default as DefaultPage } from './DefaultPage';
export { default as Menu } from './Menu';
export { default as Home } from './Home';
export { default as CourseManage } from './CourseManage';
export { default as ClassRecord } from './ClassRecord';
export { default as StartExer } from './StartExer';
export { default as ExerRecord } from './ExerRecord';
export { default as MyOrder } from './MyOrder';
export { default as Account } from './Account';
export { default as Message } from './Message';
export { default as Tabs } from './Tabs';
export { default as TabPane } from './TabPane';
export { default as CourseManageMyCourses } from './CourseManageMyCourses';
export { default as CourseManageMyQuestions } from './CourseManageMyQuestions';
export { default as CourseManageMyComment } from './CourseManageMyComment';
export { default as CourseManageMyCollect } from './CourseManageMyCollect';
export { default as ExerChoice } from './ExerChoice';
export { default as StartExerChapter } from './StartExerChapter';
export { default as StartExerQuestionStore } from './StartExerQuestionStore';
export { default as StartExerExam } from './StartExerExam';
export { default as ExerRecordIndex } from './ExerRecordIndex';
export { default as ExerRecordQuestionCollect } from './ExerRecordQuestionCollect';
export { default as ExerRecordPaperCollect } from './ExerRecordPaperCollect';
export { default as ExerRecordMyWrong } from './ExerRecordMyWrong';
export { default as ExerRecordMyNote } from './ExerRecordMyNote';
export { default as ExerRecordMyCorrection } from './ExerRecordMyCorrection';
export { default as Questions } from './Questions';
export { default as MyOrderPane } from './MyOrderPane';
export { default as AccountBasicInfo } from './AccountBasicInfo';
export { default as AccountModifyPwd } from './AccountModifyPwd';
export { default as AccountFindPwd } from './AccountFindPwd';
export { default as AccountBindPhone } from './AccountBindPhone';
export { default as ExerRecordPane } from './ExerRecordPane';
export { default as Coupon } from './Coupon';
export { default as CouponItem } from './CouponItem';
export { default as CouponExplain } from './CouponExplain';



// WEBPACK FOOTER //
// ./src/features/center/index.js